module.exports = __webpack_public_path__ + "img/BI.676f6aae.svg";